<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3 class="font-weight-bold" v-text="'Gift Order'"></h3>
              <v-btn
                rounded
                color="primary"
                :loading="isLoading"
                :disabled="isLoading"
                @click="updateStatus"
              >
                Update Gift
              </v-btn>

              <!-- <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="/gift-redemptions/create"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn> -->
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    fab
                    x-small
                    color="primary"
                    @click="updateStatus"
                  >
                    <v-icon dark> mdi-update </v-icon>
                  </v-btn>
                </template>
                <span>Update Status</span>
              </v-tooltip> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.status"
                    :items="statusItem"
                    clearable
                    @click:clear="(filter.status = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(place_orders.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Gift Redemption</span>
                  </v-tooltip>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="place_orders.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <!-- <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th> -->
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">
                        Tracking URL
                      </th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: none">user</th>
                      <th class="text-left" style="min-width: none">Phone</th>
                      <th class="text-left" style="min-width: none">Gift</th>
                      <th class="text-left" style="min-width: none">Store</th>
                      <th class="text-left" style="min-width: none">Date</th>
                      <th class="text-left" style="min-width: none">Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="place_orders.length != 0">
                    <tr
                      v-for="(gift_order, i) in place_orders"
                      :key="`gift_order_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': place_orders.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <!-- <td>
                        <input
                          type="checkbox"
                          v-model="gift_order.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td> -->
                      <td>
                        <v-tooltip bottom v-if="gift_order.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span> Gift Orders is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="gift_order.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift Order is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <div class="d-flex justify-center">
                          <v-text-field
                            v-model="gift_order.tracking_url"
                            label="Tracking URL"
                            outlined
                            dense
                            style="width: 250px"
                          ></v-text-field>
                        </div>
                      </td>

                      <td class="text-center">
                        <v-autocomplete
                          ref="Status"
                          solo
                          v-model="gift_order.status"
                          :items="statusesItems"
                          label="Status"
                          @change="dialog(gift_order, i)"
                        ></v-autocomplete>
                      </td>

                      <td>
                        {{ gift_order.user ? gift_order.user.user_name : "" }}
                      </td>
                      <td>
                        {{ gift_order.user ? gift_order.user.phone : "" }}
                      </td>
                      <td>
                        {{
                          gift_order.gift_catalog
                            ? gift_order.gift_catalog.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          gift_order.address_line1 +
                            "," +
                            gift_order.address_line2 || ""
                        }}
                      </td>
                      <td>
                        {{ formatDate(gift_order.created_at) }}
                      </td>
                      <td>
                        {{
                          gift_order.status == 0
                            ? "PENDING"
                            : gift_order.status == 1
                            ? "ORDER PLACED"
                            : gift_order.status == 2
                            ? "PICKUP"
                            : gift_order.status == 3
                            ? "IN TRANSIT"
                            : gift_order.status == 4
                            ? "OUT FOR DELIVERY"
                            : gift_order.status == 5
                            ? "DELIVERED"
                            : gift_order.status == 6
                            ? "ORDER CANCELLED"
                            : gift_order.status == 7
                            ? "REJECTED"
                            : gift_order.status == 8
                            ? "RTO"
                            : "UNKNOWN"
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_gift_order" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Add Remarks!</h1>
                      <br />
                      <!-- <h3>Add Remarks.</h3> -->
                      <v-textarea
                        v-model="delete_remark"
                        label="Add Remark (optional)"
                        outlined
                        rows="3"
                        class="mt-4"
                      ></v-textarea>

                      <br />
                      <v-btn color="success" @click="updateOrderRemark">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "GiftOrdersPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        status: "",
        update_status: "",
      },
      place_orders: [],
      delete_remark: "",
      selectedOrder: null,

      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      statusItem: [
        {
          id: "",
          text: "Select Status",
          value: "",
        },
        { id: 0, text: "PENDING", value: "0" },
        { id: 1, text: "ORDER PLACED", value: "1" },
        { id: 2, text: "PICKUP", value: "2" },
        { id: 3, text: "IN TRANSIT", value: "3" },
        { id: 4, text: "OUT FOR DELIVERY", value: "4" },
      ],
      statusesItems: [
        { id: 0, text: "PENDING", value: 0 },
        { id: 1, text: "ORDER PLACED", value: 1 },
        { id: 2, text: "PICKUP", value: 2 },
        { id: 3, text: "IN TRANSIT", value: 3 },
        { id: 4, text: "OUT FOR DELIVERY", value: 4 },
        { id: 5, text: "DELIVERED", value: 5 },
        { id: 6, text: "ORDER CANCELLED", value: 6 },
        { id: 7, text: "REJECTED", value: 7 },
        { id: 8, text: "RTO", value: 8 },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelloading: false,
      delete_gift_order: false,
      is_deleted_gift_order: false,
      is_select_all: false,
      isDeleteAll: false,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      console.log("route", this.$route.query.update_status);
      if (this.$route.query.update_status) {
        this.filter.update_status = this.$route.query.update_status;
      } else {
        this.filter.update_status = "";
      }
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&update_status=" +
        this.filter.update_status +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`place_orders?${query}`)
        .then((response) => {
          this.place_orders = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    saveRemark() {
      if (this.selectedOrder) {
        this.selectedOrder.remark = this.delete_remark;
      }
      this.is_deleted_gift_order = false;
    },

    async updateStatus() {
      try {
        this.isLoading = true;

        // const updatedOrders = this.place_orders.map((order) => ({
        //   id: order.id,
        //   tracking_url: order.tracking_url,
        //   status: order.status,
        //   remark: order.remark || "", // <-- important!
        // }));

        await axios.post(`/place_orders/update`, {
          place_orders: this.place_orders,
        });

        await this.getData();
        this.isLoading = false;
      } catch (e) {
        console.error(e);
        this.isLoading = false;
      }
    },

    // async Delete_this(id) {
    //   this.delete_gift_order = true;
    //   await axios
    //     .post(`/place_orders/delete/${this.encryptIt(id)}`)
    //     .then(() => {
    //       this.delete_gift_order = false;
    //       this.is_deleted_gift_order = true;
    //       this.getData();
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       // window.location.href = "/auth/login";
    //     });
    // },
    // selectAll() {
    //   console.log(this.is_select_all);
    //   this.place_orders.forEach((gift_order) => {
    //     gift_order.is_selected = this.is_select_all;
    //   });
    // },
    // async deleteAll() {
    //   this.isDeleteAll = true;
    //   let deleteallIds = [];
    //   this.place_orders.forEach((gift_order) => {
    //     if (gift_order.is_selected) deleteallIds.push(gift_order);
    //   });
    //   await axios
    //     .post("/place_orders/alldelete", { deleteallIds })
    //     .then(() => {
    //       this.filter.status = "";
    //       this.getData();
    //     })
    //     .catch(function (error) {
    //       this.getData();
    //       console.log(error);
    //     });
    //   // let response = await axios.post(/sync_users/update_date_all, this.form);
    //   this.isDeleteAll = false;
    // },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },
    // dialog(status, gift_order) {
    //   if (status == 3 || status == 4) {
    //     this.selectedOrder = gift_order;
    //     this.delete_remark = gift_order.remark || "";
    //     this.is_deleted_gift_order = true;
    //   }
    // },

    dialog(gift_order, index) {
      console.log("dialog Remark", status);
      if (gift_order.status == 6 || gift_order.status == 7) {
        this.selectedOrderIndex = index;

        // this.delete_remark = gift_order.remark || "";

        this.is_deleted_gift_order = true;
      }
    },
    updateOrderRemark() {
      console.log();
      this.place_orders[this.selectedOrderIndex].remarks = this.delete_remark;
      this.is_deleted_gift_order = false;
      this.delete_remark = "";
      this.selectedOrderIndex = "";
    },
    async generateExcel() {
      this.isExcelLoading = true;
      if (this.$route.query.update_status) {
        this.filter.update_status = this.$route.query.update_status;
      } else {
        this.filter.update_status = "";
      }
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.vehicle_maker = this.filter.vehicle_maker
        ? this.filter.vehicle_maker
        : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.store_id != null) {
        this.filter.store_id = this.decryptIt(this.$route.query.store_id);
      } else {
        this.filter.store_id = "";
      }
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&store_id=" +
        this.filter.store_id +
        "&position_id=" +
        this.filter.position_id +
        "&state=" +
        this.filter.state +
        "&vehicle_maker=" +
        this.filter.vehicle_maker +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&status=" +
        this.filter.status +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/place_orders/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
  },
};
</script>
